import React, { useEffect } from 'react';
import * as bd from 'react-basic-design';
import { InitFailed } from '../../../components/basic/init-failed';
import { Loading } from '../../../components/basic/loading';
import { T } from '../../../components/basic/text';

import { useDashboardIndicatorsApi, useDashboardInitApi } from '../../../api/dashboard-api';
import { tileIcons } from './sys-menu/tile-icons';
import { SysMenuTiles } from './sys-menu/sysmenu-tiles';
import settings from '../../../app/settings';

export function HomeApp() {
    const initApi = useDashboardInitApi(false);
    const indicatorsApi = useDashboardIndicatorsApi();
    const model = initApi.result;

    useEffect(() => {
        initApi.post();
    }, []);

    if (initApi.error) return <InitFailed ex={initApi.error} onRetry={() => initApi.post()} />;
    if (indicatorsApi.error)
        return <InitFailed ex={indicatorsApi.error} onRetry={() => indicatorsApi.post()} />;
    if (!model) return <Loading />;

    const style = {
        background: 'url(/images/bg/bg-map.png) center no-repeat',
        minHeight: 540,
    };

    if (!model.sysMenu.length) {
        return (
            <div className="middle pt-5" style={style}>
                <div className="text-center">
                    <T as="h5" className="text-muted">
                        app-title
                    </T>
                    <h1 className="pb-5">WELCOME</h1>
                    <div className="pt-5">
                        <T>you-dont-have-enough-permission-please-contact-administrator</T>
                    </div>
                    <div className="pt-5">
                        <T>support-tel</T>:{' '}
                        <span className="ltr d-inline-block">{settings.supportTel}</span>
                    </div>
                </div>
            </div>
        );
    }

    const admin_tiles = model.sysMenu.find(x => x.id?.toUpperCase() === 'ADMIN')?.items;
    const adminMenu = admin_tiles && (
        <bd.Menu>
            {admin_tiles.map((x, xIndex) => {
                return (
                    <React.Fragment key={x.id}>
                        {xIndex > 0 &&
                            admin_tiles[xIndex].separatorName !=
                                admin_tiles[xIndex - 1].separatorName && <bd.MenuDivider />}
                        {!!x.title && (
                            <bd.MenuItem
                                href={x.url}
                                onClick={(e: any) => e.stopPropagation()}
                                className="text-default"
                            >
                                {x.iconCode && (
                                    <span className="size-sm p-e-2">
                                        {(tileIcons as any)[x.iconCode]}
                                    </span>
                                )}
                                <T>{x.title}</T>
                            </bd.MenuItem>
                        )}
                    </React.Fragment>
                );
            })}
        </bd.Menu>
    );

    const home_tiles = model.sysMenu.filter(x => x.id?.toUpperCase() !== 'ADMIN');

    return (
        <bd.Flex className="pb-6" vertical>
            <div className="bg-shell text-shell p-3 flex-1 ">
                <bd.Flex align="center" gap={3} wrap>
                    {adminMenu && (
                        <div className="m-s-auto">
                            <bd.Button
                                variant="outline"
                                className="border border-secondary"
                                menu={adminMenu}
                                color="inherit"
                                disableRipple
                            >
                                <T>manage</T>
                            </bd.Button>
                        </div>
                    )}
                </bd.Flex>
            </div>
            <div className="launchpad-container">
                <SysMenuTiles menus={home_tiles} />
            </div>
        </bd.Flex>
    );
}
